<div class="vehicle-one-label">
    <slot />
</div>

<style>
    .vehicle-one-label {
        color: var(--list-element-header-color-inactive);
        font-size: var(--list-element-header-font-size);
    }
</style>
